var ar = require('./ar.json');
var da = require('./da.json');
var de = require('./de.json');
var el = require('./el.json');
var enUS = require('./en.json');
var esES = require('./es-ES.json');
var es = require('./es.json');
var fi = require('./fi.json');
var fr = require('./fr.json');
var hi = require('./hi.json');
var id = require('./id.json');
var it = require('./it.json');
var ja = require('./ja.json');
var ko = require('./ko.json');
var nb = require('./nb.json');
var nl = require('./nl.json');
var pl = require('./pl.json');
var ptBR = require('./pt-BR.json');
var ptPT = require('./pt-PT.json');
var sv = require('./sv.json');
var th = require('./th.json');
var tr = require('./tr.json');
var uk = require('./uk.json');
var vi = require('./vi.json');
var zhCN = require('./zh-CN.json');
var zhHK = require('./zh-HK.json');
var zhSG = require('./zh-SG.json');
var zhTW = require('./zh-TW.json');

const languages = {
  ar,
  da,
  de,
  el,
  'en-US': enUS,
  'es-ES': esES,
  es,
  fi,
  fr,
  hi,
  id,
  it,
  ja,
  ko,
  nb,
  nl,
  pl,
  'pt-BR': ptBR,
  'pt-PT': ptPT,
  sv,
  th,
  tr,
  uk,
  vi,
  'zh-CN': zhCN,
  'zh-HK': zhHK,
  'zh-SG': zhSG,
  'zh-TW': zhTW
};

module.exports = languages;
